<!-- TEMPLATE CONTRACT: Ui Form Action Footer Component owns the visible Angular template structure for src/app/shared/ui/ui-form-action-footer/ui-form-action-footer.component.html. -->
<footer class="ui-form-action-footer" [class.ui-form-action-footer--split]="usesSplitLayout()">
  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (usesSplitLayout()) {
    <div class="ui-form-action-footer__left">
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (showBack()) {
        <ui-button variant="secondary" [disabled]="disableBack()" [ariaLabel]="backLabel() | uiLabelTranslate" (click)="onBackClicked()">
          {{ backLabel() | uiLabelTranslate }}
        </ui-button>
      }
    </div>

    <div class="ui-form-action-footer__right">
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (showSave()) {
        <ui-button
          [disabled]="disableSave() || isSaving()"
          [ariaLabel]="isSaving() ? ('shared.buttons.saving' | uiLabelTranslate) : (saveLabel() | uiLabelTranslate)"
          (click)="onSaveClicked()"
        >
          {{ saveLabel() | uiLabelTranslate }}
        </ui-button>
      }
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (showNext()) {
        <ui-button variant="secondary" [disabled]="disableNext()" [ariaLabel]="nextLabel() | uiLabelTranslate" (click)="onNextClicked()">
          {{ nextLabel() | uiLabelTranslate }}
        </ui-button>
      }
    </div>
  } @else {
    <div class="ui-form-action-footer__right ui-form-action-footer__right--clustered">
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (showBack()) {
        <ui-button variant="secondary" [disabled]="disableBack()" [ariaLabel]="backLabel() | uiLabelTranslate" (click)="onBackClicked()">
          {{ backLabel() | uiLabelTranslate }}
        </ui-button>
      }
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (showSave()) {
        <ui-button
          [disabled]="disableSave() || isSaving()"
          [ariaLabel]="isSaving() ? ('shared.buttons.saving' | uiLabelTranslate) : (saveLabel() | uiLabelTranslate)"
          (click)="onSaveClicked()"
        >
          {{ saveLabel() | uiLabelTranslate }}
        </ui-button>
      }
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (showNext()) {
        <ui-button variant="secondary" [disabled]="disableNext()" [ariaLabel]="nextLabel() | uiLabelTranslate" (click)="onNextClicked()">
          {{ nextLabel() | uiLabelTranslate }}
        </ui-button>
      }
    </div>
  }
</footer>
